module.exports = __webpack_public_path__ + "img/sand-dune-decal-20.1068ad29.png";